// tslint:disable:max-line-length

import React from 'react';

export const ObjectMap = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M8,0C5.7,0,3.7,2,3.7,4.3C3.7,7.5,8,13,8,13s4.3-5.3,4.3-8.7C12.4,2,10.5,0,8,0z M8,2.1c0.9,0,1.6,0.7,1.6,1.6 S8.9,5.4,8,5.4S6.4,4.7,6.4,3.8S7.1,2.1,8,2.1z" />
      <polygon points="16,16 0,16 2,11 5.3,11 8,14.7 10.7,11 14,11 	" />
    </svg>
  );
};
